import React from "react";
import SecctionTitle from "../shared/secction_title";

const EirProgramBlock = ({ data }) => {
  console.log(
    "🚀 ~ file: eir-pogram.js ~ line 5 ~ EirProgramBlock ~ data",
    data
  );
  return (
    <div className="EirProgramBlock">
      <SecctionTitle text={data.eir_program_tittle.text}></SecctionTitle>
      <div className="layout">
        <div className="eir_content_wrap">
          <div className="text_info_wrap">
            <p className="sub">{data.eir_program_subtittle.text}</p>
            <div
              className="text_block"
              dangerouslySetInnerHTML={{
                __html: data.eir_program_text.html,
              }}
            />
            <button>
              <a href={data.eir_program_btn_link.url} target="_blank">
                {data.eir_program_btn_text.text}
              </a>
            </button>
          </div>
          <div className="photo_wrap">
            <img src={data.eir_program_img.url} alt="photo" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EirProgramBlock;
